/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { MatDialog } from '@angular/material/dialog';
import { timer } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { MyInjector } from '@src/app/app.module';
import { uuid } from '@src/app/model/abstract-object';
import { Unit } from '@src/app/model/unit';
import { IFormAction, ActionColor } from '@src/app/shared/form/form.component';
import { OwnerChangeComponent } from '@src/app/modules/unit/unit-page/owner-change/owner-change.component';

export class AddContactAction implements IFormAction {
    name = $localize`Add Contact`;
    color: ActionColor = 'primary';
    show = false;
    icon = 'group';
    approvalNeeded = false;
    disabled = false;
    approvalText = "";
    tipText = $localize `Associate additional contacts to this unit`;
    teamId: uuid;

    unit: Unit;

    action() {
        const dialog = MyInjector.instance.get(MatDialog);
        return timer(0).pipe(
            switchMap(() => dialog.open(OwnerChangeComponent, {data: {unit: this.unit, transfer: false}}).afterClosed())
        );
    }

    setup(unit: Unit) {
        if (unit?.teamId) {
            this.teamId = unit.teamId;
            this.show = true;
        } else {
            this.show = false;
        }
        this.unit = unit;
    }
}
